import type { snap as en } from '../en/snap';

/** Zumpo/Snap symbol 的名字，按变体顺序。 */
export const symbols = [
  '圆形',
  '圆环',
  '半圆',
  '方块',
  '菱形',
  '三角',
  '星星',
  '闪光',
  '六边形',
  '爱心',
  '月亮',
  '加号',
  '水滴',
  '云朵',
  '叶子',
  '花朵',
  '闪电',
  '箭头',
  '房子',
  '小鱼',
  '蝴蝶结',
  '小树',
  '蘑菇',
  '铃铛',
  '四叶草',
  '音符',
  '眼睛',
  '王冠',
  '胶囊',
  '幽灵',
  '杯子',
];
const name = (symbol: number) => symbols[symbol] ?? '';

export const snap: typeof en = {
  middleCard: '中间的牌',
  yourCard: '你的牌',
  lastCard: '最后一张',
  left: (count) => `还剩 ${count} 张`,
  won: (count) => `抢到 ${count} 张`,
  progress: (taken, total) => `${taken} / ${total} 张`,
  gameOver: '游戏结束',
  gameEnded: '游戏已中止',
  waitingRoom: '等待室',
  chat: '聊点什么…',
  you: '你',
  resultDetail: (count) => `共抢到 ${count} 张牌。`,
  alone: '叫上好友更好玩。',
  setup: (players, cards) =>
    `${players} 人，${cards} 张牌可抢。大家比谁先找到自己的牌和中间那张牌共有的图案。`,
  guestSetup: (players, cards) => `${players} 人，${cards} 张牌可抢。`,
  oneOnBoth: '两张牌上有一个相同图案',
  spot: '找出相同的图案',
  firstTakes: '最先点对的人抢到中间的牌',
  watching: '你正在观战',
  everyoneLooking: '大家都在找',
  onThisCard: '本张用时',
  paused: '已暂停',
  taken: '牌被抢走了',
  youTook: '你抢到了！',
  tookIt: (who) => `${who} 抢到了`,
  wasOnBoth: (symbol) => `两张牌上都有${name(symbol)}`,
  nextCard: '下一张',
  lockedTitle: '暂时锁定',
  notMatch: '不是这个',
  onlyOn: (symbol, on) =>
    `${name(symbol)}只在${on === 'mine' ? '你的牌' : '中间的牌'}上`,
  lockedOut: '锁定中',
  stillLocked: '还在锁定中',
  tapAfterLockout: '新牌已翻开，锁定结束后再点',
  away: '暂离',
  waiting: '等待中',
  tookCard: '抢到了牌',
  looking: '寻找中',
  solo: {
    rule: '点出两张牌上都有的图案，中间的牌就归你。点错一次加 3 秒。',
    whatMakesMatch: '怎样算相同',
    example: '任意两张牌都恰好有一个相同图案。',
    notYet: '暂无',
    complete: '本轮完成',
    allTaken: (count) => `${count} 张牌全部拿到`,
    resultTitle: (count, time) => `${count} 张牌，用时 ${time}。`,
    wrongTaps: '点错次数',
    fastest: '最快一张',
    slowest: '最慢一张',
    none: '暂无',
    best: '本机最佳成绩',
    challenge: (time) => `好友会拿到同一副牌，试着打破 ${time} 的成绩。`,
    progress: (count, total) => `第 ${count} / ${total} 张`,
    thisRun: '本轮',
    thirtyCards: '30 张牌',
    runTime: '用时',
    tapBoth: '点出两张牌上都有的图案',
    match: '找到了！',
    foundIn: (time) => `用时 ${time}`,
    wrong: '不是这个，+3 秒',
    firstRun: '这是你在本机的第一轮。',
    newBest: (time) => `刷新本机纪录！上次最佳成绩是 ${time}。`,
    previousBest: (time) => `你的本机最佳成绩是 ${time}。`,
    cost: (count, time) => (count ? `${count} 次，+${time}` : '0'),
  },
};
